import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_BUSINESS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsForChoose, optionsEnumTypePaymentMethodEnum, optionsEnumTypeOperationEnum } from './DRRateComissionTypes'
import DecimalInput from './DecimalInput';
import CurrencyInput from 'react-currency-input-field';


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






export const DRRateComissionFrom = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntityProps !== undefined ? initEntityProps : initEntity)

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchLoad] = useFetch(
        `${API_BUSINESS}drratecomission/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    
        const [, doFetchCreateUpdate] = useFetch(
            `${API_BUSINESS}drratecomission`)//{ error: errCU, isLoading: isLoadCU, response: respCU }



    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        })
    }, [currentID])


    const handleSave = () => {
        //сначала проверим заполненность

        var method = "POST"
        if (currentID !== "") {
            method = "PATCH"
        }

        doFetchCreateUpdate({
            method: method,
            "Content-Type": "application/json",
            data: entity
        }).then(responce => {
            console.log(responce)
            setEntity(responce.data)
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }



    const handleComissionPercentChange = (newPercent: number) => {
        const parsedValue = newPercent//parseFloat(newPercent);
        setEntity((prevEntity) => ({
          ...prevEntity,
          comissionPercent: isNaN(parsedValue) ? 0 : parsedValue,
        }));
      };

      const [errorMessage, setErrorMessage] = useState('');
      const [className, setClassName] = useState('');
      const [rawValue, setRawValue] = useState<string | undefined>(' ');



      const [value, setValue] = useState<string | number>('');

      const validateValue =  (_value, name, _values): void => {

        setValue(_value);

        setEntity((prevEntity) => ({
            ...prevEntity,
            comissionPercent: isNaN(_values.float) ? 0 : _values.float,
          }));

      };

      useEffect(()=>{
        if (entity && entity.idUnique)
        {
            if (value === '')
            {
                setValue(entity.comissionPercent);
            }
        }
      },[entity])


    const confirmButtonTitle = "Загрузить";//useTranslation('confirmButtonTitle')
    const rejectButtonTitle = useTranslation('rejectButtonTitle')

    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

        

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('typeBusiness')}</Form.Label>
                <Col md={9}>
                    <Select options={optionsEnumTypeOperationEnum} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypeOperationEnum.find(option => option.value === entity.typeOperation) ?? optionsEnumTypeOperationEnum[0]}
                        onChange={e => setEntity((prev) => { return { ...prev, typeOperation: e!.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('paymentMethod')}</Form.Label>
                <Col md={9}>
                    <Select options={optionsEnumTypePaymentMethodEnum} placeholder='choose one' classNamePrefix='Select' value={optionsEnumTypePaymentMethodEnum.find(option => option.value === entity.paymentMethod) ?? optionsEnumTypePaymentMethodEnum[0]}
                        onChange={e => setEntity((prev) => { return { ...prev, paymentMethod: e!.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('bank')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('bank')} value={entity.bank} onChange={e => setEntity((prev) => { return { ...prev, bank: e.target.value } })} />
                </Col>
            </Row>

            

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('comissionPercent')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control ${className}`}
                value={value}
                onValueChange={validateValue}
                placeholder="Процент комиссии"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('minimumComission')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('minimumComission')} value={entity.minimumComission} onChange={e => setEntity((prev) => { return { ...prev, minimumComission: parseFloat(e.target.value) } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('minAmountPayment')}</Form.Label>
                <Col md={9}>
                
                    <Form.Control type="text" placeholder={useTranslation('minAmountPayment')} value={entity.minAmountPayment} onChange={e => setEntity((prev) => { return { ...prev, minAmountPayment: parseFloat(e.target.value) } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('maxAmountPayment')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('maxAmountPayment')} value={entity.maxAmountPayment} onChange={e => setEntity((prev) => { return { ...prev, maxAmountPayment: parseFloat(e.target.value) } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('comments')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('comments')} value={entity.comments} onChange={e => setEntity((prev) => { return { ...prev, comments: e.target.value } })} />
                </Col>
            </Row>


      


            <Row className="mb-0">
                {canCreate && currentID === "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }

                {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {updateButtonTitle} </Button>
                }


            </Row>




        </Card.Body>
    </Card>)
}
